import React from 'react';
import { InputItem } from 'antd-mobile';
import WrapComponent from './WrapComponent';

class TextEl extends React.Component{
    render(){
        let {api_name, max_length, is_readonly, errorText, default_value, form, is_required, label} = this.props;
        const { getFieldProps } = form;
        
        let tempProps = {
            type: 'text',
            name: api_name,
            maxLength: max_length,
            disabled: is_readonly,
            placeholder: $st('请输入')
        }
        let fieldProps = getFieldProps(api_name, {
            initialValue: default_value,
            validate: [{
                trigger: 'onChange',
                rules: [{
                    required: is_required, 
                    message: $st(`paas.smart.form.isrequired`) 
                },{
                    type: 'string',
                    whitespace: true,
                    message: `${label + $st("不能为空")}`
                }],
            }],
            normalize: function(v, prev){
                if (v && v.length > max_length){
                    return v.slice(0, max_length);
                }else{
                    return v;
                }
            }
        });
        
        return (
            <InputItem {...tempProps}  {...fieldProps} >
                {errorText && <div className='input-error'>{errorText}</div>}
            </InputItem>
        )
    };
}

export default WrapComponent(TextEl);


// WEBPACK FOOTER //
// ./src/component/Text.js